import "./src/scss/style.scss";

// Custom smooth scroll with configurable duration
const smoothScrollTo = (target, duration = 1500) => {
  const targetElement = typeof target === 'string' 
    ? document.querySelector(target) 
    : target;
    
  if (!targetElement) return;

  const startPosition = window.pageYOffset || window.scrollY || 0;
  const targetPosition = targetElement.getBoundingClientRect().top + startPosition;
  const distance = targetPosition - startPosition;
  let startTime = null;

  const ease = (t, b, c, d) => {
    t /= d;
    return -c * t * (t - 2) + b;
  };

  const animation = (currentTime) => {
    if (startTime === null) startTime = currentTime;
    const timeElapsed = currentTime - startTime;
    const next = ease(timeElapsed, startPosition, distance, duration);
    window.scrollTo(0, next);
    
    if (timeElapsed < duration) {
      requestAnimationFrame(animation);
    } else {
      window.scrollTo(0, targetPosition);
    }
  };

  requestAnimationFrame(animation);
};

export const onClientEntry = () => {
  if (typeof window === 'undefined') return;

  // Wait for DOM to be ready
  const init = () => {
    // Handle initial page load with hash
    if (window.location.hash) {
      const hash = window.location.hash;
      // Only try to scroll if the hash is a valid CSS selector (starts with a letter)
      // Numeric hashes (like #5) are handled by gallery pages themselves
      if (hash.length > 1 && hash.match(/^#[a-zA-Z]/)) {
        setTimeout(() => {
          try {
            const target = document.querySelector(hash);
            if (target) {
              smoothScrollTo(target, 1500);
            }
          } catch (e) {
            // Invalid selector, ignore
          }
        }, 100);
      }
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
};

// Handle navigation after route changes in Gatsby
export const onRouteUpdate = ({ location }) => {
  if (typeof window === 'undefined') return;
  
  if (location.hash) {
    const hash = location.hash;
    // Only try to scroll if the hash is a valid CSS selector (starts with a letter)
    // Numeric hashes (like #5) are handled by gallery pages themselves
    if (hash.length > 1 && hash.match(/^#[a-zA-Z]/)) {
      setTimeout(() => {
        try {
          const target = document.querySelector(hash);
          if (target) {
            smoothScrollTo(target, 1500);
          }
        } catch (e) {
          // Invalid selector, ignore
        }
      }, 100);
    }
  }
};

// Control scroll behavior on navigation
export const shouldUpdateScroll = ({ routerProps: { location } }) => {
  // If there's a hash, prevent all scrolling
  // Gallery pages or onRouteUpdate will handle it
  if (location.hash) {
    return false;
  }
  
  // No hash: instantly scroll to top (no animation)
  if (typeof window !== 'undefined') {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }
  return false;
};
